import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatDividerModule } from '@angular/material/divider';

@Component({
  selector: 'sca-card-view',
  templateUrl: './card-view.component.html',
  styleUrls: ['./card-view.component.scss'],
  imports: [
    MatCardModule,
    MatDividerModule
  ]
})
export class CardViewComponent {
  @Input('cardTitle') cardTitle: string = '';
  @Input('contentCssClass') contentClass: string = '';

  @Input('hideDivider') hideDivider: boolean = false;
}
